export const queryParamToString = (value: string | string[] | undefined): string | undefined =>
  typeof value === 'string' ? value : undefined;
